<!--分层作业（学生成长中心）-->
<template>
    <div class="fczy-home">
        <!--文件列表-->
        <div v-show="showMode==='list'" class="fczy-panel">
            <div class="fczy-body">
                <!--目录-->
                <div class="fczy-side">
                    <div class="fczy-side-title">目录</div>
                    <el-scrollbar class="fczy-tree-scroll">
                        <el-tree
                          class="fczy-tree"
                          :data="categoryList"
                          :props="defaultProps"
                          @node-click="handleNodeClick">
                        </el-tree>
                    </el-scrollbar>
                </div>
                <!--文件卡片-->
                <div class="fczy-main">
                    <div class="fczy-search">
                        <svg t="1775018007241" class="icon cursor" @click="resetSearch" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8064" width="30" height="30"><path d="M512 57.677643C261.084506 57.677643 57.677643 261.084506 57.677643 512s203.406863 454.322357 454.322357 454.322357 454.322357-203.406863 454.322357-454.322357S762.915494 57.677643 512 57.677643z" fill="#ff7f2e" p-id="8065" data-spm-anchor-id="a313x.search_index.0.i11.35603a81rpIomP" class="selected"></path><path d="M581.060548 231.577511c-41.567834-41.568721-84.297206-66.239667-95.428104-55.108769-11.137997 11.137109 13.540936 53.86027 55.108769 95.428991a399.812548 399.812548 0 0 0 3.868839 3.816485c-18.446198-2.465941-38.703473-3.828908-59.958128-3.828908-77.080402 0-141.021837 17.917338-153.042745 41.397463-17.152444 22.420631-29.056222 71.617886-29.056222 128.705442 0 78.219757 22.352305 141.629671 49.931092 141.629671 27.578787 0 49.939965-63.409913 49.939965-141.629671 0-29.986163-3.285851-57.794773-8.891231-80.689248 25.579591 5.930149 57.067147 9.428076 91.118253 9.428076 22.752499 0 44.362094-1.561733 63.828742-4.367528a399.907494 399.907494 0 0 0-7.739452 7.534475c-41.568721 41.568721-66.240555 84.298094-55.109657 95.428991 11.137109 11.137109 53.86027-13.540049 95.428991-55.10877 34.770745-34.770745 57.718461-70.344541 57.776139-87.567972a16.620035 16.620035 0 0 0 0.897109-5.344499c0-2.19175-0.448111-4.351556-1.316825-6.468769-3.259231-18.402718-25.271681-51.17338-57.355535-83.25546z m40.5181 350.441373c0 29.983501 3.284076 57.788562 8.887681 80.682149-25.582253-5.927487-57.071584-9.425414-91.124464-9.425414-22.751612 0-44.360319 1.561733-63.825193 4.365754a405.916617 405.916617 0 0 0 7.747439-7.542461c41.568721-41.568721 66.240555-84.285671 55.102558-95.42278-11.130898-11.130898-53.853172 13.533837-95.42278 55.102558-34.768971 34.768971-57.715799 70.348977-57.779688 87.573296a16.628908 16.628908 0 0 0-0.894447 5.340063c0 2.184652 0.444562 4.337359 1.307064 6.447473 3.242371 18.400055 25.269019 51.187577 57.367958 83.287403 41.568721 41.567834 84.285671 66.240555 95.42278 55.102559 11.130898-11.130898-13.533837-53.853172-55.102558-95.42278a410.577858 410.577858 0 0 0-3.868839-3.81826c18.440873 2.466828 38.693712 3.828908 59.945706 3.828908 77.092825 0 141.048458-17.930648 153.056943-41.416985 17.148007-22.42773 29.051785-71.612562 29.051785-128.681483 0-78.228631-22.361179-141.638544-49.939966-141.638544-27.578787 0-49.931092 63.409913-49.931091 141.638544z" fill="#FFFFFF" p-id="8066"></path></svg>
                        <div class="fczy-search-right">
                            <el-select v-model="queryParams.categoryProfile" placeholder="请选择学段" @change="changeProfile">
                                <el-option v-for="item in profileList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                            <el-select v-model="queryParams.categorySubject" placeholder="请选择学科" @change="changeSubject">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                            <el-input v-model="queryParams.fileName" placeholder="请输入文件名称" clearable
                                      class="fczy-search-input"
                                      @keyup.enter="queryFileList(null)">
                                <template #append>
                                    <el-button type="primary" @click="queryFileList(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </div>
                    </div>
                    <div class="fczy-card-container" v-loading="loading">
                        <el-empty v-if="!loading && dataList.length == 0" description="暂无数据" />
                        <div v-for="(item, index) in dataList" :key="index" class="fczy-card">
                            <img class="fczy-card-cover"
                                 :src="item.fileCover || defaultCover"
                                 @click="handleView(item)" />
                            <div class="fczy-card-name" :title="item.fileName">{{ item.fileName }}</div>
                        </div>
                    </div>
                    <div class="fczy-pagination">
                        <pagination :background="false"
                                    :pageSizes="[12, 24, 36]"
                                    :total="total"
                                    v-model:page="queryParams.pageNum"
                                    v-model:limit="queryParams.pageSize"
                                    @pagination="queryFileList" />
                    </div>
                </div>
            </div>
        </div>
        <!--文件预览-->
        <div v-show="showMode==='view'" class="fczy-panel">
            <div class="fczy-view-head">
                <div class="fczy-view-title" :title="fileForm.fileName">{{ fileForm.fileName }}</div>
                <el-button class="fczy-download-btn" type="primary" size="small" icon="Download"
                           @click="handleDownload">下载</el-button>
            </div>
            <file-image-preview v-if="imagePreviewMode" class="fczy-view-preview"
                                :title="fileForm.fileName" :img-url="fileForm.imgUrl" :pages="fileForm.pages" />
        </div>
        <!--图片文件预览-->
        <el-dialog v-model="imageVisible" :title="fileForm.fileName" width="60%" top="5vh" append-to-body>
            <div class="fczy-image-view">
                <img :src="fileForm.fileUrl" :alt="fileForm.fileName" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {treeFileCategory, pageCategoryFile, infoFile} from "@/api/admin/fileCategory"
import {queryDict, downloadFile} from "@/api/adminservice/public"
import fileImagePreview from "@/components/material/fileImagePreview.vue"

export default {
    name: "homeworkHome",
    components: {fileImagePreview},
    props: {
        title: {
            type: String,
            default: '分层作业'
        },
        courseMode: {
            type: String,
            default: 'page'
        },
    },
    data() {
        return {
            defaultCover:'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/fczy_file.png',
            loading: false,
            showMode: 'list',
            categoryList: [],
            profileList: [],
            subjectList: [],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            //查询文件分页
            queryParams: {
                pageNum: 1,
                pageSize: 12,
                categoryProfile: '',
                categorySubject: '',
                fileName: '',
                categoryId: '',
            },
            total: 0,
            dataList: [],
            //文件预览
            fileForm: {},
            //图片预览弹窗
            imageVisible: false,
            //word/pdf/ppt按页图片预览模式
            imagePreviewMode: false,
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getQueryDict();
    },
    mounted(){},
    methods: {
        // 查询学段学科字典
        getQueryDict() {
            queryDict({ code: 'hierarchy_homework' }).then(res => {
                if (res.data.code === 1) {
                    this.profileList = res.data.data || [];
                    if (this.profileList.length > 0) {
                        // 默认第一个学段、第一个学科
                        const currentProfile = this.profileList[0];
                        this.queryParams.categoryProfile = currentProfile.dictKey;
                        this.subjectList = currentProfile.childrenList || [];
                        if (this.subjectList.length > 0) {
                            this.queryParams.categorySubject = this.subjectList[0].dictKey;
                        }
                    }
                    // 学段学科同时不为空才查询
                    if (this.queryParams.categoryProfile && this.queryParams.categorySubject) {
                        this.queryTreeCategory();
                        this.queryFileList(null);
                    }
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 学段切换，学科为学段子集
        changeProfile() {
            this.subjectList = [];
            this.profileList.forEach(e => {
                if (this.queryParams.categoryProfile === e.dictKey) {
                    this.subjectList = e.childrenList || [];
                }
            })
            this.queryParams.categorySubject = this.subjectList.length > 0 ? this.subjectList[0].dictKey : '';
            this.queryParams.categoryId = '';
            // 学段学科同时不为空才查询
            if (this.queryParams.categoryProfile && this.queryParams.categorySubject) {
                this.queryTreeCategory();
                this.queryFileList(null);
            }
        },
        // 学科切换
        changeSubject() {
            this.queryParams.categoryId = '';
            // 学段学科同时不为空才查询
            if (this.queryParams.categoryProfile && this.queryParams.categorySubject) {
                this.queryTreeCategory();
                this.queryFileList(null);
            }
        },
        // 查询树结构
        queryTreeCategory(){
            treeFileCategory({
                categoryProfile: this.queryParams.categoryProfile,
                categorySubject: this.queryParams.categorySubject,
            }).then(res => {
                if (res.data.code === 1) {
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleNodeClick(e){
            this.queryParams.categoryId = e.categoryId;
            this.queryFileList();
        },
        resetSearch(){
            this.queryParams.fileName = '';
            this.queryParams.categoryId = '';
            this.queryFileList(null);
        },
        queryFileList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageCategoryFile(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 预览文件
        handleView(file){
            infoFile({fileId: file.fileId}).then((res) => {
                if (res.data.code === 1) {
                    this.fileForm = res.data.data;
                    // fileType为文件后缀名，统一转小写并去掉可能带有的前缀点，不区分大小写
                    const fileType = (this.fileForm.fileType || '').toLowerCase().replace(/^\./, '');
                    // 图片文件：直接弹窗展示图片
                    if (/^(png|jpe?g|gif|bmp|webp|svg)$/.test(fileType)) {
                        this.imageVisible = true;
                        return;
                    }
                    // word/pdf/ppt文件：页内按页图片预览，替换iframe方式
                    if (/^(doc|docx|pdf|ppt|pptx)$/.test(fileType)) {
                        if (this.fileForm.imgUrl && Number(this.fileForm.pages) > 0) {
                            this.imagePreviewMode = true;
                            this.showMode = 'view';
                        } else {
                            this.$message.info("文件正在处理，请稍后刷新预览")
                        }
                        return;
                    }
                    // 其他文件暂不支持预览，提示用户下载使用
                    this.handleUnsupport(this.fileForm);
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        // 暂不支持预览的文件，提示下载使用
        handleUnsupport(file){
            this.$confirm("暂不支持预览，可下载使用", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                downloadFile(file.fileUrl, file.fileName);
            }).catch(() => {});
        },
        // 下载文件
        handleDownload(){
            downloadFile(this.fileForm.fileUrl, this.fileForm.fileName);
        },
        backList(){
            this.showMode = 'list';
            this.imagePreviewMode = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.fczy-home {
    width: 100%;
}

.fczy-panel {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 24px;
    padding: 22px 26px;
    box-sizing: border-box;
    height: calc(100vh - 174px);
    min-height: 0;
}

.fczy-body {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 20px;
}

/*目录*/
.fczy-side {
    flex-shrink: 0;
    width: 220px;
    display: flex;
    flex-direction: column;
    background: #f2f8ff;
    border-radius: 16px;
    padding: 14px;
    box-sizing: border-box;
    min-height: 0;
}

.fczy-side-title {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 700;
    color: #17365d;
    margin-bottom: 10px;
}

.fczy-tree-scroll {
    flex: 1;
    min-height: 0;
}

.fczy-tree {
    background: transparent;
}

/*文件卡片*/
.fczy-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.fczy-search {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    .fczy-search-right {
        display: flex;
        align-items: center;
        gap: 12px;

        .el-select {
            width: 140px;
        }

        .fczy-search-input {
            width: 260px;
        }
    }
}

.fczy-card-container {
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    /*无数据时暂无数据提示居中*/
    :deep(.el-empty) {
        margin: auto;
    }
}

.fczy-card {
    width: 200px;
    margin: 0 16px 16px 0;
    background: #ffffff;
    border: 1px solid #e4eefb;
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }
}

.fczy-card-cover {
    width: 100%;
    height: 150px;
    object-fit: fill;
    display: block;
}

.fczy-card-name {
    padding: 8px 12px;
    font-size: 14px;
    color: #17365d;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fczy-pagination {
    flex-shrink: 0;
    position: relative;

    /*覆盖分页组件内联的 absolute/right:0，使其居中*/
    :deep(.el-pagination) {
        position: static !important;
        justify-content: center;
    }
}

/*文件预览*/
.fczy-view-head {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.fczy-view-title {
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #ff7f2e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/*下载按钮：固定在标题行最右侧*/
.fczy-download-btn {
    flex-shrink: 0;
    margin-left: 12px;
    background-color: #ff7f2e;
    border-color: #ff7f2e;
}

/*word/pdf/ppt按页图片预览*/
.fczy-view-preview {
    flex: 1;
    min-height: 0;
    width: 100%;
}

/*图片预览*/
.fczy-image-view {
    display: flex;
    justify-content: center;
    max-height: calc(100vh - 200px);
    overflow: auto;
    background: #f2f8ff;
    border-radius: 12px;

    img {
        max-width: 100%;
        display: block;
    }
}
</style>
